/**
 * Purchase object
 */
const yup = require('yup');

const {
  PaymentTypes
} = require('../enums');

const {
  requiredString,
  validateObject,
  requiredArrayOf,
  requiredObject,
  requiredNumber,
  requiredBool,
  optionalObject,
  arrayOf,
  optionalString
} = require('../utils');

const {
  purchasablePricingOption,
  sparseLocationsSchema,
  contactInfoSchema
} = require('../common');

const COLLECTION = 'purchases';
const SCHEMA = yup.object().shape({
  orgId: requiredString(),
  total: requiredNumber().default(0),
  cart: requiredArrayOf(requiredObject().shape({
    autoRenew: requiredBool().default(false),
    locations: sparseLocationsSchema(),
    purchasableId: requiredString(),
    purchasableTitle: requiredString(),
    option: purchasablePricingOption(),
    total: requiredNumber().default(0)
  })),
  stripe: optionalObject().shape({
    charge: optionalString(),
    subscriptions: arrayOf(requiredString())
  }),
  user: requiredString(),
  contactInfo: contactInfoSchema(),
  completed: requiredBool().default(false),
  paymentReceived: requiredBool().default(true),
  paymentType: requiredString().oneOf(PaymentTypes.map(type => type.value)).default(PaymentTypes[0].value)
});

async function validate(purchase) {
  return validateObject(SCHEMA, purchase);
}
/**
 * This object defines custom queries to perform on the data, outside of the normal CRUD operations
 */


const QUERIES = {
  getPendingCheckPaymentPurchases: () => {
    return {
      where: [["paymentType", "==", "CHECK"], ["paymentReceived", "==", false]] // orderBy: ["createdAt", "ASC"]

    };
  }
};
/**
 * Methods added here will trigger https-callable Cloud Functions
 */

const CALLABLES = {};
/**
 * Methods added here will be appended to each returned document from the collection
 */

const MIXINS = {};
/**
 * Dates are a bit of a pitd with Firestore, so implement this method to convert any timestamp fields to JS Date objects
 * when records are inflated from Firestore, since ultimately we need to pass Date objects back to Firestore when saving
 * records
 * @param model The inflated object from Firestore
 * @returns the model with the appropriate Timestamps converted to JS Dates
 */

const convertDates = model => {
  return model;
};

module.exports = {
  QUERIES,
  CALLABLES,
  MIXINS,
  COLLECTION,
  SCHEMA,
  validate,
  convertDates
};